<div [hidden]="!visible">
  <p-treetable #pTable class="rt-scroll-tt" [class.table-large]="tableLarge()" [columns]="selectColumns()"
    [class.mobile-table]="navigationService.isMobileOrTablet()" [hidden]="!filtering.value" 
    [value]="treeNodes" [rows]="20" [paginator]="!hidePaginator" [first]="first || 0"
    [resetPageOnSort]="true" [selectionMode]="selectionMode()!" [(selection)]="selectedNode" dataKey="id"
    (onNodeSelect)="nodeSelect($event)" [customSort]="true" (sortFunction)="defaultSort($event)"
    [(contextMenuSelection)]="selectedNode" [contextMenu]="cm">

    <!-- ===== CAPTION ===== -->
    <ng-template pTemplate="caption">

      <!-- <div class="row-cols-sm-1 ">
        <div class-="col">
          <div #searchContainer class="w-100 p-0 gap-2 d-flex">
            <p-iconfield class="w-100">
              <p-inputicon *ngIf="request.isLoading" styleClass="pi-spin pi-spinner" />
      
              <p-inputicon *ngIf="!request.isLoading" styleClass="pi pi-search" />
              <input #searchText [(ngModel)]="searchValue.term" pInputText (input)="setGlobalContentFilter($event.target)"
                type="text" placeholder="Buscar..." (keyup)="setSearchText(searchText.value)">
            </p-iconfield>
            <button pButton severity="secondary" icon="pi pi-pencil" pTooltip="Editar tabla"></button>
          </div>
        </div>
        <div class="col mt-2 d-flex flex-wrap gap-2 w-100 justify-content-between align-items-center">
          <ng-template *ngIf="headerActions" ngFor let-col [ngForOf]="[cols]" let-i="index" [ngForTemplate]="headerActions">
              <div class="w-100">
                {{col}}
              </div>
          </ng-template>
        </div>
      </div> -->

      <div class="d-flex justify-content-between align-items-center align-content-center p-0" 
        [class.flex-wrap]="navigationService.isMobileOrTablet()" 
        [class.gap-3]="navigationService.isMobileOrTablet()"
        [class.container-fluid]="navigationService.isMobileOrTablet()">

        <!-- LEFT -->
        <div class="d-flex w-100 gap-4 "
          [class.justify-content-between]="navigationService.isMobileOrTablet()"
          [class.flex-wrap]="navigationService.isMobileOrTablet()"
          [class.order-1]="navigationService.isMobileOrTablet()">

          <p-iconfield class="w-50" [class.w-100]="navigationService.isMobileOrTablet()"
            [class.order-3]="navigationService.isMobileOrTablet()">
            <p-inputicon *ngIf="request.isLoading" styleClass="pi pi-spinner" />
          
            <p-inputicon *ngIf="!request.isLoading" styleClass="pi pi-search" />
            <input #searchText [(ngModel)]="searchValue.term" pInputText (input)="setGlobalContentFilter($event.target)"
              type="text" placeholder="Buscar..." (keyup)="setSearchText(searchText.value)">
          </p-iconfield>

          
          <button *ngIf="!showExportCsv" class="badge btn text-white text-nowrap" [class.order-3]="navigationService.isMobileOrTablet()" (click)="exportCsv()"
            style="background-color:#27A745;font-size: .8rem;">
            <i class="fa fa-download"></i>
            Exportar a CSV
          </button>

          <button *ngIf="enableFilter" class="btn btn-outline-dark"
            style="font-size:0.8em;margin-left:8px;" (click)="filterPressed.emit()">
            <i class="fa fa-filter" style="margin:4px 4px 0 0"></i>
            Filtros
          </button>

          <div class="d-flex gap-2 w-100 justify-content-between flex-wrap">
            <ng-template *ngIf="header" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="header">
            </ng-template>
          </div>
        </div>
        
        <div class="d-flex w-100 gap-2 align-items-center mx-2" [class.w-100]="navigationService.isMobileOrTablet()">
          <ng-template *ngIf="center" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="center">
          </ng-template>
        </div>
       
        

        <!-- RIGHT -->
        @if (actionButtonText && ['tomega', 'detorres'].includes(this.appName) || !['gerencia','aplicador'].includes(this.rol)) {
          <div class="d-flex align-items-center text-left" 
              [class.w-100]="navigationService.isMobileOrTablet()"
              [class.order-1]="navigationService.isMobileOrTablet()"
              [class.mt-2]="navigationService.isMobileOrTablet()">
            <div>
              <span *ngIf="request.hasError" style="margin-right:10px" tooltipPosition="bottom"
                pTooltip="Ha ocurrido un error...">
                <i class="fa fa-exclamation-triangle" style="color:black"></i>
              </span>
            </div>
            @if(showAddButton()) {

              <button *ngIf="actionButtonText !== ''"  pButton  icon="pi pi-plus"
                (click)="actionButtonClick.emit()" 
                class="text-nowrap"
                [class.w-100]="navigationService.isMobileOrTablet()"
                style="font-weight: bold;background-color:#2196f3; font-size:.8rem; border: none !important;">
                
                {{actionButtonText}}
              </button>
            }
          </div>
        }

      </div>
    </ng-template>

    <!-- ===== COLGROUP ===== -->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of cols" [style.width]="5">
      </colgroup>
    </ng-template>

    <!-- ===== HEADER ===== -->
    <ng-template pTemplate="header">
      <tr class="small">
        <th *ngIf="selectionMode() === 'checkbox'" >
          <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
        </th>

        <ng-template *ngIf="thStart" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thStart">
        </ng-template>

        <th *ngFor="let col of cols" [ttSortableColumn]="col.field" class="rt-clamp">
          <div class="d-flex justify-content-center align-items-center" *ngIf="!col.filter">
            {{col.header}}
            <p-treeTableSortIcon *ngIf="col.sort !== false" [field]="col.field" class="ms-2" />
          </div>

          <div *ngIf="col.filter">
            {{col.header}}
            <div [ngSwitch]="col.filter">
              <p-select *ngSwitchCase="'dropdown'" [options]="dropdown[col.field]"
                [style]="{'width':'100%','fontSize':'0.7em'}" (onChange)="setDropdownSelectOn($event.value,col.field)">
              </p-select>

              <p-multiSelect *ngSwitchCase="'multiselect'" [options]="multiselect[col.field]"
                [(ngModel)]="filters.multiselect[col.field]" [style]="{'width':'100%','fontSize':'0.7em'}"
                (onChange)="setMultiSelectOn($event.value,col.field)">
              </p-multiSelect>

              <p-datePicker *ngSwitchCase="'calendar'" [(ngModel)]="filters.dateRange[col.field]"
                (onClose)="setDateRangeOn()" (onClearClick)="cleanDateRangeOn(col.field)" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="2005:2030" showButtonBar="true" selectionMode()="range"
                readonlyInput="true">
              </p-datePicker>
            </div>
          </div>
        </th>

        <!-- Columna de Acciones -->
        <th *ngIf="hasEditableFields && editButtonsPosition === 'tableEnd'" class="rt-actions">
          <div class="d-flex justify-content-center align-items-center min-height-40">
            <span>Acciones</span>
          </div>
        </th>

        <ng-template *ngIf="thEnd" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thEnd">
        </ng-template>
      </tr>
    </ng-template>

    <!-- ===== BODY ===== -->
    <ng-template pTemplate="body" let-data>
      <tr class="base-row-style" [ttRow]="data" [ttSelectableRow]="data"
        [ngStyle]="processRowConditionalStyle(data.node)" [ttContextMenuRow]="data">

        <td *ngIf="selectionMode() === 'checkbox'">
          <p-treeTableCheckbox [value]="data"></p-treeTableCheckbox>
        </td>

        <ng-template *ngIf="tdStart" ngFor let-data [ngForOf]="[data.node]" [ngForTemplate]="tdStart">
        </ng-template>

        <!-- Celdas dinámicas -->
        <td *ngFor="let col of cols" class="ui-resizable-column" [attr.data-label]="col.header"
          [ngStyle]="processCellConditionalStyle(data.node,col)" ttEditableColumn>

          <div *ngIf="col.editable" class="edit-field">
            <p-treeTableCellEditor>
              <ng-template pTemplate="input">
                <p-datePicker class="input-edit-field" [(ngModel)]="data.node.data[col.field]" hourFormat="24"
                  dateFormat="hh:mm" dataType="string" [timeOnly]="true" placeholder="..."
                  [ngModelOptions]="{updateOn:'blur'}" (onBlur)="editField($event,data.node,col.field)">
                </p-datePicker>
              </ng-template>
              <ng-template pTemplate="output">
                {{processCellVisualTransform(data.node,col)}}
              </ng-template>
            </p-treeTableCellEditor>
          </div>

          <div *ngIf="!col.editable" class="rt-cell">
            {{processCellVisualTransform(data.node,col)}}
          </div>
        </td>

        <!-- Columna Acciones -->
        <td *ngIf="hasEditableFields && editButtonsPosition === 'tableEnd'" class="rt-actions"
          [attr.data-label]="'Acciones'">
          <div class="rt-actions-wrap">
            <button class="rt-icon rt-save" (click)="saveButtonClick.emit()">
              <i class="fa fa-save"></i>
            </button>
            <button class="rt-icon rt-undo" (click)="undoButtonClick.emit()">
              <i class="fa fa-undo"></i>
            </button>
          </div>
        </td>

        <ng-template *ngIf="tdEnd" ngFor let-data [ngForOf]="[data.node]" [ngForTemplate]="tdEnd">
        </ng-template>
      </tr>
    </ng-template>

    <!-- ===== FOOTER ===== -->
    <ng-template pTemplate="footer" *ngIf="footer">
      <tr *ngIf="selectionMode()  === 'checkbox'" class="base-row-style">
        <td style="font-size:0em">
  
        </td>
        <td *ngIf="thStart" style="font-size:0em">
          <ng-template *ngIf="thStart" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thStart">
          </ng-template>
        </td>

        <td *ngFor="let col of cols">
          <ng-template *ngIf="footer" ngFor let-col [ngForOf]="[col]" [ngForTemplate]="footer">
          </ng-template>
        </td>

        <td *ngIf="thEnd" style="font-size:0em">
          <ng-template *ngIf="thEnd" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thEnd">
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-treetable>

  <p-contextMenu #cm [model]="menuItems"></p-contextMenu>
  <br>
</div>

<a href="#" id="csvLink" style="visibility:hidden;position:fixed;"></a>